//#region IMPORT
import React, { useEffect } from 'react';
import { BusinessGridGridCommon } from '../../../../Components/BusinessGridGridCommon';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import { Typography, Paper, Button, Box } from '@mui/material';
import { Dialog } from '../../../../Components/MUIs';
import { Download as DownloadIcon } from '@mui/icons-material';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { useSelector } from 'react-redux';
import { getColumnDefs1, getColumnDefs2 } from './TRA_CUSTOM_05_ColumnDefs';
import { toPreviewSrc } from '../../../../util';

function TRA_CUSTOM_05(props) {
  // 현재 클릭된 행의 SESSION_CD를 추적하기 위한 ref
  const clickedSessionCdRef = React.useRef(null);
  const searchInfo = useSelector((state) => state.SearchInfo);

  const columnDefs1 = getColumnDefs1(props);
  const columnDefs2 = getColumnDefs2(props);
  const audioPath = props.selectedRowData1?.[0]?.meetPath;
  const audioUrl = toPreviewSrc(audioPath);

  //#region AuthButton 이벤트
  useEffect(() => {
    if (props.filterClick5) {
      if (!props.validateSelection()) {
        props.setFilterClick5(false);
        return;
      }

      props.gridRef1.current.api.setQuickFilter(searchInfo.searchText);
      props.setFilterClick5(false);
    }
    if (props.searchClick5) {
      props.ResetLogic1();
      if (!props.validateSelection()) {
        props.setSearchClick5(false);
        return;
      }

      props.SearchLogic1();
      props.setSearchClick5(false);
    }
    if (props.addClick5) {
      if (!props.validateSelection()) {
        props.setAddClick5(false);
        return;
      }

      GridFunctions.addClick(props.gridRef1);
      props.setAddClick5(false);
    }
    if (props.saveClick5) {
      if (!props.validateSelection()) {
        props.setSaveClick5(false);
        return;
      }

      props.SaveLogic1();
      props.setSaveClick5(false);
    }
    if (props.deleteClick5) {
      if (!props.validateSelection()) {
        props.setDeleteClick5(false);
        return;
      }

      props.DeleteLogic1();
      props.setDeleteClick5(false);
    }
    if (props.printClick5) {
      if (!props.validateSelection()) {
        props.setPrintClick5(false);
        return;
      }

      props.PrintLogic1();
      props.setPrintClick5(false);
    }
    if (props.listClick5) {
      if (!props.validateSelection()) {
        props.setListClick5(false);
        return;
      }

      props.setModalToggle3(true);
      props.setListClick5(false);
    }
  }, [
    props.filterClick5,
    props.searchClick5,
    props.addClick5,
    props.saveClick5,
    props.deleteClick5,
    props.printClick5,
    props.listClick5,
  ]);
  //#endregion

  return (
    <React.Fragment>
      <BusinessGridGridCommon
        gridId={props.gridId1}
        getRowId1={(params) => params.data.no}
        title1={'교육현황'}
        title2={'참석자 정보'}
        addYn1="N"
        addYn2="N"
        deleteYn1="Y"
        deleteYn2="N"
        leftSize={60}
        rightSize={40}
        gridRef1={props.gridRef1}
        gridRef2={props.gridRef2}
        columnDefs1={columnDefs1}
        columnDefs2={columnDefs2}
        rowData1={props.rowData1}
        rowData2={props.rowData2}
        setSelectedRowData1={props.setSelectedRowData1}
        setSelectedRowData2={props.setSelectedRowData2}
        setChangedRowData1={props.setChangedRowData1}
        setChangedRowData2={props.setChangedRowData2}
        onCellClicked1={(e) => {
          const currentSessionCd = e.data.sessionCd;
          // 이미 클릭된 행을 다시 클릭한 경우 조회하지 않음
          if (clickedSessionCdRef.current === currentSessionCd) {
            return;
          }
          // 새로운 행을 클릭한 경우에만 조회
          clickedSessionCdRef.current = currentSessionCd;
          props.sessionCdRef.current = currentSessionCd;

          props.SearchLogic2({ sessionCd: props.sessionCdRef.current });
        }}
        onSelectionChanged1={() => {
          const gridApi = props.gridRef1?.current?.api;
          const selectedNodes = gridApi.getSelectedNodes();
          const selectedData = selectedNodes.map((n) => n.data);

          props.selectedRowNosRef1.current = new Set(
            selectedData.map((r) => r.no)
          );
          props.setSelectedRowData1(selectedData);
        }}
        refreshClick1={() => {
          if (!props.validateSelection()) return;

          props.SearchLogic1();
        }}
        refreshClick2={() => {
          if (!props.validateSelection()) return;

          props.SearchLogic2({ sessionCd: props.sessionCdRef.current });
        }}
        deleteClick1={(e) => {
          const newRowExists = props.selectedRowData1.some(
            (row) => row.newYn === 'Y'
          );

          if (!newRowExists) {
            props.MarkedForDeletion1(props.selectedRowData1);
          } else {
            props.NewYnErrorMsg();
          }
        }}
      />
      {props.modalToggle1 && (
        <Dialog
          title={'내용 보기'}
          open={props.modalToggle1}
          onClose={() => {
            props.setModalToggle1(false); // 모달 닫기
          }}
          contentSx={{ display: 'flex', flexDirection: 'column' }}
          closeButtonName={'닫기'}
          useSaveAfterClose={true}
          maxWidth={false}
          PaperProps={{
            sx: {
              display: 'flex',
              flexDirection: 'column',
              p: 3,
              width: '70vw',
              maxWidth: '1080px',
              minWidth: '760px',
              height: '88vh',
              bgcolor: '#f9fafb',
            },
          }}
          previewRender={props.PreviewRender}
          onSave={() => {
            const api = props.gridRef1?.current?.api;
            const clickedRowData = props.rowClickData.current;
            const uploadedFile = props.previewUrl?.file;

            if (!api || !clickedRowData || !uploadedFile?.name) {
              console.warn('파일명 또는 선택된 행이 없습니다.');
              return;
            }

            let targetRowNode = null;
            api.forEachNode((node) => {
              if (node.data === clickedRowData) {
                targetRowNode = node;
              }
            });

            if (targetRowNode) {
              const fileName = uploadedFile.name;

              targetRowNode.setDataValue('FILE_NAME', fileName);
              targetRowNode.setDataValue('mapFile', uploadedFile);
            } else {
              console.warn('대상 행을 찾을 수 없습니다.');
            }

            // 모달 닫기 및 상태 초기화
            props.setModalToggle1(false);
            props.setPreviewFile(null);
          }}
          content={
            <Box
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                pt: 1,
                gap: 2,
              }}
            >
              {/* 상단 영역 */}
              <Paper
                elevation={2}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                  p: 2.5,
                  borderRadius: 2,
                  border: '1px solid #e5e7eb',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 2,
                    flexWrap: 'wrap',
                  }}
                >
                  <Typography sx={{ fontWeight: 600, color: '#374151' }}>
                    회의 녹음 파일
                  </Typography>
                  <Box
                    sx={{
                      flex: 1,
                      minWidth: '280px',
                      px: 1.5,
                      py: 1,
                      borderRadius: 1.5,
                      bgcolor: '#f3f4f6',
                      color: '#4b5563',
                      border: '1px solid #e5e7eb',
                      fontSize: '0.9rem',
                    }}
                  >
                    {audioPath ? audioPath.split('/').pop() : '파일 없음'}
                  </Box>
                  <Button
                    variant="contained"
                    color="success"
                    disabled={!audioPath}
                    onClick={() => props.DownloadLogic1(audioPath)}
                    startIcon={<DownloadIcon />}
                    sx={{ whiteSpace: 'nowrap', px: 2 }}
                  >
                    파일 다운로드
                  </Button>
                </Box>
                <Box
                  sx={{
                    p: 1.5,
                    borderRadius: 2,
                    border: '1px solid #e5e7eb',
                    bgcolor: '#fff',
                  }}
                >
                  <AudioPlayer
                    src={audioUrl}
                    autoPlay={false}
                    customAdditionalControls={[]} // 불필요한 버튼 제거
                    style={{ width: '100%' }}
                  />
                </Box>
              </Paper>

              {/* 미리보기 영역 */}
              <Paper
                elevation={2}
                sx={{
                  p: 2.5,
                  flexGrow: 1,
                  minHeight: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: 2,
                  border: '1px solid #e5e7eb',
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1.5, fontWeight: 600, color: '#374151' }}
                >
                  TBM 사진
                </Typography>
                <Box
                  sx={{
                    border: '1px dashed #cbd5e1',
                    borderRadius: 2,
                    flexGrow: 1,
                    minHeight: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'auto',
                    bgcolor: '#fff',
                    p: 2,
                  }}
                >
                  {props.PreviewRender
                    ? props.PreviewRender()
                    : '미리보기 영역'}
                </Box>
              </Paper>
            </Box>
          }
        />
      )}
    </React.Fragment>
  );
}

export default TRA_CUSTOM_05;
